import React from "react";
import RadioButton from "../../../../common/components/radio/RadioButton";
import { radioChoicesType } from "../../../../common/types/search/search";

interface RadioButtonsProps {
	choices: radioChoicesType;
	criterionKey: string;
	currentInput: string;
	label: string;
	onInputChange: (id: string) => void;
}

export default function RadioButtons({
	label,
	currentInput,
	criterionKey,
	onInputChange,
	choices,
}: RadioButtonsProps) {
	const radioButtons = choices.map((choice) => {
		const { key, value } = choice;

		return (
			<RadioButton
				key={key}
				id={key}
				label={value}
				criterionKey={criterionKey}
				onInputChange={onInputChange}
				currentInput={currentInput}
			/>
		);
	});

	return (
		<fieldset>
			<legend>{label}</legend>

			{radioButtons}
		</fieldset>
	);
}
